import { render, staticRenderFns } from "./InstructorView.vue?vue&type=template&id=667794b1&"
import script from "./InstructorView.vue?vue&type=script&lang=js&"
export * from "./InstructorView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports